<template>
  <div>
    <a-row>
      <a-col :span="24">
        <span style="font-size: 20px; color: black"
          >Finding and Choosing a Perturbed Gene:</span
        >
        <a-select
          style="width: 60%; margin-left: 10px"
          @search="handleSearch"
          @change="handleChange"
          show-search
          :filter-option="true"
          :value="value"
        >
          <a-select-option v-for="item in options" :key="item" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-col>
      <br />
      <a-divider dashed style="margin-top: 20px"></a-divider>
      <a-col :span="24">
        <detailTable v-bind:gene="this.value" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import detailTable from "./gacTable.vue";

export default {
  components: { detailTable },
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/scATAC/genelist.php", {
        params: {
          datasetId: this.$route.query.datasetId,
          gene: "A",
        },
      })
      .then((response) => {
        this.options = response.data.slice(0, 20);
        this.value = this.defaultGene[this.$route.query.datasetId];
      });
  },
  methods: {
    handleChange(value) {
      this.value = value;
    },
    handleSearch(value) {
      if (value == "") {
        this.options = [];
      } else {
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/scATAC/genelist.php",
            {
              params: {
                datasetId: this.$route.query.datasetId,
                gene: value,
              },
            }
          )
          .then((response) => {
            this.options = response.data.slice(0, 20);
          });
      }
    },
  },
  data() {
    return {
      value: "",
      defaultGene: {
        scATAC00001: "ARID1A",
        scATAC00002: "TOP2B",
        scATAC00003: "MYC",
        scATAC00004: "MYC",
        scATAC00005: "MYC",
        scATAC00006: "NFKB2",
      },
      options: [],
    };
  },
};
</script>

<style></style>
